import { isDefinedArray, reduce } from "et3-type-guards";

import i18n from "../../../../constants/i18n";
import { EVENTS_COUNT_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getAuditStore from "../../../../stores/auditor-store/audit-store";
import EventsTable from "./EventsTable";
import Et3Table from "../../../../core/et3-table";
import React from "react";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

//JC HERE NEEDS CLEANING BY SEPERATING FILES AND FIX EVENTS DATA IN A SAME FILE AND LESS CONDITION
const AuditData = withLiteObserverAndTheme(() => {
  const typeInput = getAuditStore().typeInputAudit.get().value;
  const eventsData =
    typeInput === "report"
      ? getAuditStore().adminReportEventsData.get()
      : getAuditStore().adminEventsData.get();
  const eventsCount = reduce(() => eventsData.eventsCount, []);
  const totalEvents = reduce(() => eventsData.totalEvents, 0);
  const totalEventsRow = {
    type: `Total Events: ${totalEvents}`,
    totalClean: "-",
    totalIssues: "-"
  };
  const finalData = [...eventsCount, totalEventsRow];

  const shouldShow = isDefinedArray(getAuditStore().eventsListOrdered.get());
  return (
    <React.Fragment>
      <EventsTable />
      {shouldShow ? (
        <React.Fragment>
          <Et3Margin top={30} bottom={0} left={0} right={0} />
          <Et3Table
            columns={EVENTS_COUNT_HEADERS}
            rows={finalData}
            title={i18n.get("EVENTS_COUNT")}
            shouldBeFlagged={false}
            titleKey={"EVENTS_COUNT"}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
});

export default AuditData;
